import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';

import {Empresa} from '../../../../../chacra-core';

export {Empresa} from '../../../../../chacra-core';

export const empresasAdapter: EntityAdapter<Empresa> = createEntityAdapter<Empresa>({
  selectId: model => model.empresaId,
  sortComparer: (a: Empresa, b: Empresa): number =>
    b.empresaId.toString().localeCompare(a.empresaId.toString())
});

export interface EmpresasState extends EntityState<Empresa> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: EmpresasState = empresasAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);

// util

export function getEmpresaResponsableContacto(e: Empresa) {
  if (!e || !e.contactos || e.contactos.length === 0) {
    return null;
  }
  return e.contactos[0];
}
